import axios from './client';

const CONSTANT = '/constant';

// eslint-disable-next-line import/prefer-default-export
export function search() {
  return axios.get(CONSTANT);
}
